"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/BQFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_32)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_32`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.08008 0H34.9199V24H-1.08008V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.08008 24H34.9199V0L-1.08008 24Z",
					fill: "#012A87"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.4919 0H-1.08008V11.7123L16.4919 0Z",
					fill: "#F9D90F"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.77258 8.30176L9.62872 9.78948H11.348L10.4849 11.2702L11.348 12.7579H9.62872L8.77258 14.2456L7.91644 12.7579H6.19714L7.0603 11.2702L6.19714 9.78948H7.91644L8.77258 8.30176Z",
					fill: "#DC171D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.77251 15.3193C11.0088 15.3193 12.8216 13.5064 12.8216 11.2702C12.8216 9.03389 11.0088 7.22104 8.77251 7.22104C6.53624 7.22104 4.72339 9.03389 4.72339 11.2702C4.72339 13.5064 6.53624 15.3193 8.77251 15.3193Z",
					stroke: "black",
					strokeWidth: .631579,
					strokeMiterlimit: 10
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_32`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as BQFlag };
